export const getSecondFlowId = state => state.secondFlows.secondFlow.id;
export const getSecondFlowData = state => state.secondFlows.secondFlow;
export const secondFlowIsFetching = state => state.secondFlows.loading;